import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import TooltipMUI6 from 'src/components/TooltipMUI6';

/**
 * CON-1896 / CON-1263 — marks a phone number that belongs to an active CP user
 * (a userPhoneNumberInfo row with status Active). The server sends it as
 * `isCpNumber` on phone1Info..phone3Info.
 *
 * The copy says "CP number" and never "free": texting a CP number only costs
 * nothing when the viewing consultant is on CP Texting, and this indicator is
 * shown to everyone.
 */
export const CP_NUMBER_TOOLTIP = 'CP number: this phone number belongs to an active Connection Point user.';

function CpNumberIndicator({ sx = {} }) {
  return (
    <TooltipMUI6 title={CP_NUMBER_TOOLTIP}>
      <Box
        component="span"
        role="img"
        aria-label="CP number"
        sx={{
          display: 'inline-block',
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: 'success.main',
          flexShrink: 0,
          ml: 1,
          cursor: 'default',
          ...sx,
        }}
      />
    </TooltipMUI6>
  );
}

CpNumberIndicator.propTypes = {
  sx: PropTypes.object,
};

export default CpNumberIndicator;
